import captured from "./plans-catalog.json";
import type { OnboardingPlan } from "./plans-types";

// Anonymous live data capture, not billing configuration. Source/digest: onboarding-plan-display spec.
const ORDER = ["starter2", "plus", "pro2", "scale"] as const;
const BADGES: Record<string, string> = { MOST_POPULAR: "Most popular", BEST_VALUE: "Best value" };

export const VERIFIED_ONBOARDING_PLANS: readonly OnboardingPlan[] = ORDER.map((code) => {
  const row = captured.plans.find((plan) => plan.code === code);
  if (row === undefined) throw new Error(`Missing verified display plan ${code}`);
  const creditLine = row.features.find((line) => /^[\d,]+ credits per month$/.test(line));
  if (creditLine === undefined) throw new Error(`Missing advertised credits for ${code}`);
  return {
    code, name: row.displayName, description: row.description,
    monthlyPriceCents: Math.round(row.monthlyPrice * 100),
    yearlyPriceCents: Math.round(row.yearlyPrice * 100),
    // Advertised display allowance only; never used for grants, balance or authorization.
    creditsPerMonth: Number(creditLine.split(" ")[0]!.replaceAll(",", "")),
    features: row.features.slice(1),
    ...(row.badge === null ? {} : { badge: BADGES[row.badge] ?? row.badge }),
  };
});
